"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowCartButton = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const Button_1 = require("../../../../../components/base/atoms/Button");
const Currency_1 = require("../../../../../components/base/atoms/Currency");
const getOrderMainItemImage_1 = require("../../helpers/getOrderMainItemImage");
const useConfig_1 = require("../../../../../hooks/useConfig");
const standardSizes_1 = require("../../../../../types/standardSizes");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ShowCartButton");
const ShowCartButton = ({ setShowCart }) => {
    const { baseLocationImageUrl } = (0, useConfig_1.useConfig)();
    const { salesOrderItems, totalPrice, totalItems } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const showCart = (0, react_1.useCallback)(() => {
        if (totalItems === 0) {
            return null;
        }
        setShowCart(true);
    }, [totalItems]);
    const mainItemImage = (0, react_1.useMemo)(() => (0, getOrderMainItemImage_1.getOrderMainItemImage)(salesOrderItems) || baseLocationImageUrl, [salesOrderItems]);
    return (React.createElement("div", { className: css("") },
        React.createElement(Button_1.Button, { className: css("button"), onClick: totalItems > 0 ? showCart : null, size: standardSizes_1.TStandardSizes.ExtraSmall },
            React.createElement("div", { className: css("button_mainItemImage"), style: { backgroundImage: `url("${mainItemImage}")` } },
                React.createElement("span", { className: css("button_mainItemImage_totalItems") }, totalItems)),
            React.createElement("div", { className: css("button_text") },
                totalPrice !== 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Currency_1.Currency, null, totalPrice),
                    React.createElement("span", { className: css("button_text_separator") }, " - "))),
                React.createElement("span", null, "view cart")))));
};
exports.ShowCartButton = ShowCartButton;
//# sourceMappingURL=index.js.map